import { Button, CardView, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
const WalkthroughBubbleContent = ({ title, description, numberOfSteps, currentStep, hideNumberOfSteps, doneTitle, backOnLastStep, onPressDone, onPressNext, onPressPrevious, onPressReset, cardStyle, }) => (<CardView withPadding noMarginTop noMarginBottom style={cardStyle}>
    <View style={styles.bubbleHeader}>
      <Text Text-16 OffBlack>
        {title}
      </Text>
    </View>
    {typeof description === 'string' ? (<Text TextThin-14 Secondary>
        {description}
      </Text>) : (description)}
    <Spacer h={16}/>
    <View style={styles.bubbleFooter}>
      {!hideNumberOfSteps ? (<Text Text-14>
          {currentStep + 1}/{numberOfSteps}
        </Text>) : (<View />)}
      {currentStep === 0 ? (<Button brand small square hug title={numberOfSteps === 1 ? doneTitle ?? 'Done' : 'Next'} onPress={numberOfSteps === 1 ? onPressDone : onPressNext}/>) : (<View style={styles.bubbleButtons}>
          <Button brandReversed small square hug title={currentStep === numberOfSteps - 1 && !backOnLastStep
            ? 'Restart'
            : 'Back'} onPress={currentStep === numberOfSteps - 1 && !backOnLastStep
            ? onPressReset
            : onPressPrevious}/>
          <Spacer w={8}/>
          <Button brand small square hug title={currentStep === numberOfSteps - 1 ? 'Done' : 'Next'} onPress={currentStep === numberOfSteps - 1 ? onPressDone : onPressNext}/>
        </View>)}
    </View>
  </CardView>);
const styles = StyleSheet.create({
    bubbleHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: rem(4),
    },
    bubbleFooter: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    bubbleButtons: {
        flexDirection: 'row',
    },
});
export default memo(WalkthroughBubbleContent);
